export const CLEAR_COMPLAINTS = 'clearComplaints';

export default function clearComplaints() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_COMPLAINTS,
      payload: {},
    });
  };
}
